import { RelatedPostCard } from '.';
import { postPath } from '@paths';
import { getAlternativePostPath } from '@helpers';

export const RelatedPostsBlock: React.FC<{
  posts?:
    | {
        title?: string | null;
        featuredImage?: {
          node?: { sourceUrl?: string | null | undefined } | string | null;
        } | null;
        slug?: string | null;
        categories?: {
          nodes?: ({ slug?: string | null } | null | undefined)[] | null;
        } | null;
      }[]
    | null;
  text?: string | null;
}> = ({ text, posts }) =>
  posts?.length ? (
    <div className='my-16'>
      <h2 className='mb-2 text-2xl font-bold'>{text}</h2>
      <div className='row-gap-8 lg:col-gap-8 lg:col-gap-16 lg:row-gap-16 grid grid-cols-1 lg:mb-16 lg:grid-cols-3'>
        {posts.map((post) => (
          <RelatedPostCard
            key={post.slug}
            title={post.title}
            coverImage={post.featuredImage?.node}
            href={
              post.slug
                ? postPath(post.slug, getAlternativePostPath(post))
                : undefined
            }
          />
        ))}
      </div>
    </div>
  ) : null;
